import { IonContent, IonHeader, IonPage, IonToolbar } from "@ionic/react";
import Header from "../components/layout/Header";

const LocalhostIframe = () => {
  return (
    <IonPage>
      <IonHeader mode="ios">
        <Header />
      </IonHeader>
      <IonContent>
        <div
          style={{
            width: "100%",
            height: "calc(100% - 60px)",
            position: "relative",
            aspectRatio: "16/9", // Maintain aspect ratio for responsiveness
            maxWidth: "100vw",
            maxHeight: "100vh",
          }}
        >
          <iframe
            src="https://exams.loonlog.ca/"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              display: "block",
              minHeight: 300,
            }}
            frameBorder="0"
            title="Students"
            scrolling="auto"
            allowFullScreen
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default LocalhostIframe;

